import React, { useCallback, useEffect, useRef, useState } from 'react';

import { downloadSettingExcel } from "src/utils/blob/blobUtil";

import { useKSK1070_R01Store } from './Store_KSK1070_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, showWarning } from 'src/utils/toast/toastUtil';
import useUserStore from 'src/store/useUserStore';
import { getWmsOrderInPopupList } from 'src/apis/wmsOrderApi';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';

import { deleteKSK1070_R01, downloadExcel_KSK1070_R01, getKSK1070_R01DetailList, getKSK1070_R01One, getKSK1070_R01TransportHeader, getKSK1070_R01WmsTransport, patchKSK1070_R01, postKSK1070_R01, createKSK1070_R01LotNo } from "./Api_KSK1070_R01";
import { defaultKSK1070_R01DetailDto, defaultKSK1070_R01HeaderDto, defaultKSK1070_R01LotDto, KSK1070_R01DetailDto, KSK1070_R01Dto, KSK1070_R01HeaderDto, KSK1070_R01LotDto } from './Dto_KSK1070_R01';
import { AgGridReact } from 'ag-grid-react';
import { InsertRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { formatDate, validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	KSK1070_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { LabelPrintData } from 'src/apis/labelApi';
import { KSK1070_R01_extractUnprintedLabelData } from './labelDataBuilder_KSK1070_R01';
import { useQzPrint } from 'src/hooks/useQzPrint';


interface Props {
	gridRef: React.RefObject<AgGridReact<KSK1070_R01HeaderDto> | null>;
	lotGridRef: React.RefObject<AgGridReact<KSK1070_R01LotDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<KSK1070_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}

export const Content_KSK1070_R01 = (props: Props) => {
	const { printBulkLabel } = useQzPrint();

	const {
		gridRef, lotGridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	
	const {
		KSK1070_R01Filter, setKSK1070_R01Filter,
		KSK1070_R01PastFilter, setKSK1070_R01PastFilter,
		editKSK1070_R01, setEditKSK1070_R01,
		deletedKSK1070_R01DetailList, setDeletedKSK1070_R01DetailList, addDeletedKSK1070_R01DetailList, removeDeletedKSK1070_R01DetailList, 
		selectedKSK1070_R01DetailList, setSelectedKSK1070_R01DetailList, addSelectedKSK1070_R01DetailList, removeSelectedKSK1070_R01DetailList,
		KSK1070_R01DetailList, setKSK1070_R01DetailList, insertKSK1070_R01DetailList,
		originalKSK1070_R01DetailList, setOriginalKSK1070_R01DetailList,
		KSK1070_R01LotMap, setKSK1070_R01LotMap,
		selectedItemCdForLot, setSelectedItemCdForLot,
		setKSK1070_R01LotList, insertKSK1070_R01LotList, resetKSK1070_R01LotList,
		selectedKSK1070_R01LotList, setSelectedKSK1070_R01LotList, addSelectedKSK1070_R01LotList, removeSelectedKSK1070_R01LotList, initSelectedKSK1070_R01LotList,
		deletedKSK1070_R01LotList, setDeletedKSK1070_R01LotList, addDeletedKSK1070_R01LotList, removeDeletedKSK1070_R01LotList,
		originalKSK1070_R01LotList, setOriginalKSK1070_R01LotList,
		transportComplete, setTransportComplete,
		detailFetchTrigger, setDetailFetchTrigger,
		lotFetchTrigger, setLotFetchTrigger,
		initData, 
		setAutoLotQtyIfEmpty,
		warehouseCdListToUseList,
	} = useKSK1070_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { company } = useUserStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { inoutClassList, inoutTypeList, inoutMethodList, wmsCdList, wmsInTypeCdList, yesNoList, compCdList, customCdList, employeeCdList, warehouseCdList } = useCommonCodeStore();

	const wmsOrderInfoHandleFocusId = 'inputWmsOrderNo_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'wmsOrderNo',
			category: '입고지시',
			focusId: wmsOrderInfoHandleFocusId,
			responseMapping: {
				wmsOrderNo: 'wmsOrderNo',
				compCd: 'compCd',
				compNm: 'compNm',
				customCd: 'customCd',
				customNm: 'customNm',
				orderDt: 'orderDt',
				deadlineDt: 'deadlineDt',
				logicCenter: 'logicCenter',
				warehouseCd: 'warehouseCd',
				empNo: 'empNo',
				empNm: 'empNm',
				remark: 'remark',
				inoutClass: 'inoutClass',
				inoutMethod: 'inoutMethod',
				closeTag: 'closeTag',
				inoutType: 'inoutType',
			},
			searchFunction: async (code: string) => {
				const res = await getWmsOrderInPopupList(code);
				return res.data.data.find(v => v.wmsOrderNo === code);
			},
			extraFilter: () => ({
				wmsOrderNo: editKSK1070_R01?.wmsOrderNo || '',
			}),
			onAfterConfirm: (fields) => {
				setEditKSK1070_R01({ ...defaultKSK1070_R01HeaderDto, ...fields });
				setDetailFetchTrigger(true);
			},
		},
	];

	const { getFieldHandlers: getWmsOrderFieldHandlers } = useInfoFormEvents({
		editData: editKSK1070_R01,
		setEditData: setEditKSK1070_R01,
		defaultData: { ...defaultKSK1070_R01HeaderDto, inserted: true },
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK1070_R01'
	});

	useFetchActionbarAuth("KSK1070_R01");

	const [clickable, setClickable] = useState(true);

	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);
	const prevWarehouseCdRef = useRef<string | undefined>(undefined);
	
	const handleExcelClick = useCallback(async () => {
		if (!editKSK1070_R01?.wmsOrderNo) {
			showWarning("선택된 입고정보내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_KSK1070_R01('', editKSK1070_R01.wmsOrderNo, editKSK1070_R01.warehouseCd, 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '입고정보 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [editKSK1070_R01])

	const fetchOne = useCallback(async () => {
		if (!editKSK1070_R01?.wmsOrderNo) return;

		const response = await getKSK1070_R01One(editKSK1070_R01.wmsOrderNo);

		return response.data.data as KSK1070_R01HeaderDto;
	}, [editKSK1070_R01?.wmsOrderNo]);
	

	const defaultKSK1070_R01HeaderRow = useCallback(() => {
		const logicCenter = wmsCdList[0]?.minorCd ?? '';
		const warehouseCdListToUse = warehouseCdList.filter(value =>
			value.logicCenter === logicCenter && value.materialYn === 'Y'
		);

		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(KSK1070_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				inoutClassList,
				inoutMethodList,
				inoutTypeList,
				wmsCdList,
				warehouseCdList: warehouseCdListToUse,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultKSK1070_R01HeaderDto };
		}

		return {
			...defaultKSK1070_R01HeaderDto,
			compCd: compCdList[0].compCd,
			inoutClass: inoutClassList.find(value => value.minorCd === '110')?.minorCd || '',
			inoutType: inoutTypeList.find(value => value.minorCd === 'IN')?.minorCd || '',
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
			inoutMethod: inoutMethodList[0].minorCd,
			inserted: true,
		};
	}, [
		defaultKSK1070_R01HeaderDto, compCdList, wmsCdList, warehouseCdList,
		inoutMethodList, inoutClassList, inoutTypeList, validateCommonCodeLists,
	]);

	const defaultKSK1070_R01DetailRow = useCallback(() => {
		return {
			...defaultKSK1070_R01DetailDto,
			inserted: true,
		}
	}, [defaultKSK1070_R01DetailDto]);

	const defaultKSK1070_R01LotRow = useCallback(() => {
		return {
			...defaultKSK1070_R01LotDto,
			lotInputOption: 'N', // 로트입력여부 값 고정(N: 입력안함)
			inserted: true,
		}
	}, [defaultKSK1070_R01LotDto]);

	const fetchTransportHeader = useCallback(async () => {
		if (!editKSK1070_R01?.wmsOrderNo) return;

		const response = await getKSK1070_R01TransportHeader(editKSK1070_R01.wmsOrderNo);

		return response.data.data as KSK1070_R01HeaderDto;
	}, [editKSK1070_R01?.wmsOrderNo])
	
	const initContainerData = useCallback(() => {
		prevWmsOrderNoRef.current = undefined;
		prevWarehouseCdRef.current = undefined;
		initData();
		setKSK1070_R01Filter({ labelPrintAuto: company?.labelPrintAuto || 'N' });
		removeDeletedKSK1070_R01DetailList();
		removeSelectedKSK1070_R01DetailList();
		setEditKSK1070_R01({ ...defaultKSK1070_R01HeaderRow(), })
	}, [initData, company, setKSK1070_R01Filter, removeDeletedKSK1070_R01DetailList, removeSelectedKSK1070_R01DetailList, setEditKSK1070_R01, defaultKSK1070_R01HeaderRow])

	const fetchSelectedOrder = useCallback(() => {
		const wmsOrderNo = editKSK1070_R01?.wmsOrderNo;
		if (validateString(wmsOrderNo || '')) {
			prevWmsOrderNoRef.current = undefined;
			prevWarehouseCdRef.current = undefined;
			setDetailFetchTrigger(true);
			return;
		}
		getWmsOrderFieldHandlers('wmsOrderNo')
			.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
	}, [editKSK1070_R01, setDetailFetchTrigger, getWmsOrderFieldHandlers]);

	const handleSearchClick = useCallback(() => {
		fetchSelectedOrder();
	}, [fetchSelectedOrder]);

	const handleDeleteClick = useCallback(() => {

		if (deletedKSK1070_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedKSK1070_R01DetailList(deletedKSK1070_R01DetailList);
			removeSelectedKSK1070_R01DetailList();
			setKSK1070_R01DetailList([...KSK1070_R01DetailList]);
		} else if (selectedKSK1070_R01DetailList.length > 0) {
			addDeletedKSK1070_R01DetailList(selectedKSK1070_R01DetailList);
			removeSelectedKSK1070_R01DetailList(selectedKSK1070_R01DetailList);
		}
	}, [selectedKSK1070_R01DetailList, 
		deletedKSK1070_R01DetailList,
		addDeletedKSK1070_R01DetailList,
		removeDeletedKSK1070_R01DetailList,
		removeSelectedKSK1070_R01DetailList,
		setKSK1070_R01DetailList,
		KSK1070_R01DetailList]);
	
	const handleCreateClick = () => {
		setEditKSK1070_R01({ ...defaultKSK1070_R01HeaderRow(), })
		setKSK1070_R01DetailList([{...defaultKSK1070_R01DetailRow(), inserted: true}]);
		setDeletedKSK1070_R01DetailList([]);
		setSelectedKSK1070_R01DetailList([]);
		setOriginalKSK1070_R01DetailList([]);
	}

	const handleInsertClick = useCallback((e: React.MouseEvent, rowIndex?: number) => {
		const isGridInsert = rowIndex !== undefined;
		const lotGridData = KSK1070_R01LotMap?.get(selectedItemCdForLot || '') || [];

		InsertRowHandler({
			event: e,
			dataList: lotGridData,
			rowData: isGridInsert
				? lotGridData[rowIndex]
				: { ...defaultKSK1070_R01LotRow(), valueIndex: -1 },
			insertRow: insertKSK1070_R01LotList,
			defaultRowData: defaultKSK1070_R01LotRow(),
			...(isGridInsert && { setClickable }),
		});
	}, [KSK1070_R01LotMap, selectedItemCdForLot, insertKSK1070_R01LotList, defaultKSK1070_R01LotRow, setClickable]);

	const validateInsertData = (header: KSK1070_R01HeaderDto, detailList: KSK1070_R01DetailDto[]) => {
		
		//현재 예외입고 기능 없음
		if(!validateString(header.wmsOrderNo)) {
			showWarning('입고지시항목을 선택해서 저장해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('물류센터를 선택해주세요.'); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('창고번호를 선택해주세요.'); return false;
		}
		// if (!validateString(header.empNo)) {
		// 	showWarning('입고담당자를 선택해주세요.'); return false;
		// }
		// if (!validateEmployeeCd(header.empNo, employeeCdList)) {
		// 	showWarning('입고담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		// }
		if(!validateString(header.inoutMethod)) {
			showWarning('입고구분을 선택해주세요.'); return false;
		}

		if(detailList.length === 0) {
			showWarning('상세내역을 입력해주세요.'); return false;
		}

		// 품목코드와 품목상태의 조합이 중복되는지 체크
		const itemStatusPairs = new Set<string>();
		for(const item of detailList) {
			if(!validateString(item.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if(!validateString(item.itemStatus)) {
				showWarning('품목의 상태를 선택해주세요.'); return false;
			}
			if(item.orderQty <= 0) {
				showWarning('수량을 입력해주세요.'); return false;
			}

			const pair = `${item.itemCd}-${item.itemStatus}`;
			if (itemStatusPairs.has(pair)) {
				showWarning(`품목코드 '${item.itemCd}'와(과) 품목상태 '${item.itemStatus}'의 조합이 중복되었습니다.`);
				return false;
			}
			//중복되지 않으면 검증용 set에 추가
			itemStatusPairs.add(pair);

			if(item.orderQty < item.transportQty + item.updateTransportQty) {
				showWarning(`입고량이 주문잔량보다 클 수 없습니다. - 품목코드: ${item.itemCd}, 품목상태: ${item.itemStatus}`); return false;
			}
		}
		

		return true;
	}

	const setInfoDetailList = useCallback((header: KSK1070_R01HeaderDto, detailList: KSK1070_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}))
	}, [setKSK1070_R01DetailList])

	
	const setInfoLotList = useCallback((lotMap: Map<string, KSK1070_R01LotDto[]>): Record<string, KSK1070_R01LotDto[]> => {
		const filteredLotMap: Record<string, KSK1070_R01LotDto[]> = {};

		lotMap.forEach((lots, itemCd) => {
			const filteredLots = lots.filter(lot => lot.lotQty && lot.lotQty > 0 && lot.inserted === true);
			if (filteredLots.length > 0) {
				filteredLotMap[itemCd] = filteredLots;
			}
		});

		return filteredLotMap;
	}, []);

	const refetchResponseDetailList = useCallback((responseData: KSK1070_R01Dto) => {
		
		let detailDtoList = responseData.wmsOrderDetailDtoList;

		detailDtoList = detailDtoList.map(value => ({
			...value,
			//주문잔량 다시 계산
			orderQtyView: value.orderQty - value.transportQty - value.updateTransportQty - value.cancelQty,
		}));

		//orderQtyView가 0이면 행을 삭제
		detailDtoList = detailDtoList.filter(value => value.orderQtyView > 0);
		responseData.wmsOrderDetailDtoList = detailDtoList;

		return responseData;
	}, [KSK1070_R01DetailList]);
	
	const assignLotNoToMaps = useCallback(async (currentLotMap: Map<string, KSK1070_R01LotDto[]>) => {
		const newLotMap = new Map<string, KSK1070_R01LotDto[]>();
		const promises: Promise<void>[] = [];

		for (const [itemCd, lots] of Array.from(currentLotMap.entries())) {
			const newLots = lots.map(lot => ({ ...lot }));
			
			newLots.forEach((lot) => {
				if (!validateString(lot.lotNo)) {
					const promise = createKSK1070_R01LotNo().then((res) => {
						if (res.data && res.data.successFlag) {
							lot.lotNo = res.data.data;
						}
					});
					promises.push(promise);
				}
			});
			newLotMap.set(itemCd, newLots);
		}

		if (promises.length > 0) {
			await Promise.all(promises);
			setKSK1070_R01LotMap(newLotMap);
		}

		return newLotMap;
	}, [setKSK1070_R01LotMap]);

	const handleSaveClick = useCallback(async () => {
		let valid = true;
		if(!validateInsertData(editKSK1070_R01!, KSK1070_R01DetailList)) valid = false;
		if(!valid) { return; }
		setLoadingSpinner(true);
		
		// STEP 0: 초기화 전에 LOT 번호 가져와서 KSK1070_R01LotMap의 각 row에 추가
		// ========================================
		const newLotMap = await assignLotNoToMaps(KSK1070_R01LotMap);

		// STEP 1: 저장 전에 미출력 라벨 데이터만 추출 (Lot라벨자동출력=Y일 때만). 저장 완료 후 STEP FINAL에서 일괄 출력
		let unprintedLabelData: LabelPrintData[] = [];
		if(KSK1070_R01Filter.labelPrintAuto === 'Y') {
			const store = useKSK1070_R01Store.getState();
			unprintedLabelData = KSK1070_R01_extractUnprintedLabelData(
				store,
				deletedKSK1070_R01LotList
			);
		}
		
		const lotMapObject = setInfoLotList(newLotMap);
		const deletedKSK1070_R01DetailList_Number = deletedKSK1070_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: KSK1070_R01DetailDto[] = [];
		let responseData: KSK1070_R01Dto = {
			wmsOrderHeaderDto: editKSK1070_R01!,
			wmsOrderDetailDtoList: KSK1070_R01DetailList,
			wmsStockLotDtoList: lotMapObject
		};

		const wmsOrderNo = editKSK1070_R01?.wmsOrderNo || '';

		if (wmsOrderNo !== '') {

			newDetailList = KSK1070_R01DetailList
			.map(value => ({
				...value,
				transportQty: value.transportQty + value.updateTransportQty,
			}))
			.filter(value => 
				!deletedKSK1070_R01DetailList_Number.includes(value.valueIndex)
			);

			if (newDetailList.length === 0) {
				processName = 'delete';
				const deleteResponse = await deleteKSK1070_R01(wmsOrderNo);

				if(!deleteResponse || !deleteResponse.data.successFlag) { setLoadingSpinner(false); return; }

				if (deleteResponse && deleteResponse.data) {
					if (deleteResponse.data.successFlag) {
						showSuccess('입고내역이 삭제 되었습니다.');
						setMessage('입고내역이 삭제 되었습니다.');
					}else return;
				}
			} else {
				processName = 'patch';
				const patchResponse = await patchKSK1070_R01({
					wmsOrderHeaderDto: editKSK1070_R01!,
					wmsOrderDetailDtoList: setInfoDetailList(editKSK1070_R01!, newDetailList),
					wmsStockLotDtoList: lotMapObject
				});

				if(!patchResponse || !patchResponse.data.successFlag) { setLoadingSpinner(false); return; }

				responseData = patchResponse.data.data[0];
				responseData = refetchResponseDetailList(responseData);
				
				if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {

					showSuccess('입고내역이 등록 되었습니다.');
					setMessage('입고내역이 등록 되었습니다.');
				}
			}
		} else {
			//예외입고 과정은 나중에 듣기
			processName = 'post';
			const postResponse = await postKSK1070_R01({
				wmsOrderHeaderDto: editKSK1070_R01!,
				wmsOrderDetailDtoList: setInfoDetailList(editKSK1070_R01!, KSK1070_R01DetailList),
				wmsStockLotDtoList: lotMapObject
			});

			if(!postResponse || !postResponse.data.successFlag) { setLoadingSpinner(false); return; }

			responseData = postResponse.data.data[0];
			responseData = refetchResponseDetailList(responseData);
			
			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('입고내역이 등록 되었습니다.');
				setMessage('입고내역이 등록 되었습니다.');
			}
		}


		if (processName === 'delete') {
			setEditKSK1070_R01({ ...defaultKSK1070_R01HeaderRow(), });
			setKSK1070_R01DetailList([]);
			setOriginalKSK1070_R01DetailList([]);
			setKSK1070_R01LotList([]);
			setOriginalKSK1070_R01LotList([]);
			setKSK1070_R01LotMap(new Map<string, KSK1070_R01LotDto[]>());
			setSelectedKSK1070_R01DetailList([]);
			setSelectedItemCdForLot(null);
		}else if (processName === 'patch' || processName === 'post') {
			setKSK1070_R01DetailList(responseData.wmsOrderDetailDtoList);

			const restoreLotMap = new Map<string, KSK1070_R01LotDto[]>();
			if(responseData.wmsOrderDetailDtoList) {
				responseData.wmsOrderDetailDtoList.forEach(detailItem => {
					restoreLotMap.set(detailItem.itemCd, [{...defaultKSK1070_R01LotRow(), inserted: true}]);
				})
			}
			

			//마감완료시에는 모든 상태를 초기화, 해당 입고정보 삭제
			if (responseData.wmsOrderHeaderDto!.closeTag === 'Y') {

				setEditKSK1070_R01({ ...defaultKSK1070_R01HeaderRow(), })

				setKSK1070_R01DetailList([]);
				setOriginalKSK1070_R01DetailList([]);
				setKSK1070_R01LotList([]);
				setOriginalKSK1070_R01LotList([]);
				setKSK1070_R01LotMap(new Map<string, KSK1070_R01LotDto[]>());
				setSelectedKSK1070_R01DetailList([]);
				setSelectedItemCdForLot(null);
			} else{
			
				setKSK1070_R01LotMap(restoreLotMap);
				setEditKSK1070_R01(responseData.wmsOrderHeaderDto);
				setSelectedKSK1070_R01DetailList([1 as any]);
				setOriginalKSK1070_R01DetailList(responseData.wmsOrderDetailDtoList);
				if(responseData.wmsOrderDetailDtoList.length > 0){
					setSelectedItemCdForLot(responseData.wmsOrderDetailDtoList[0].itemCd);
				} else {
					setSelectedItemCdForLot(null);
				}
				setDetailFetchTrigger(true);

			}
		}

		setDeletedKSK1070_R01DetailList([]);
		setTimeout(() => {
			setMessage('');
		}, 5000)
		
		setLoadingSpinner(false);

		// STEP FINAL: 저장 성공 후 미출력 라벨 일괄 출력 (Lot라벨자동출력=Y이고, 삭제가 아닐 때만)
		if (
			KSK1070_R01Filter.labelPrintAuto === 'Y'
			&& unprintedLabelData.length > 0 && processName !== 'delete'
		) {
			try {
				const ok = await printBulkLabel(unprintedLabelData, 'label1');
				if (ok) {
					showSuccess(`저장 완료! ${unprintedLabelData.length}개 라벨 출력`);
				} else {
					showWarning('저장은 완료되었으나 라벨 출력에 실패했습니다. 프린터 설정을 확인해주세요.');
				}
			} catch (error: any) {
				console.error('라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${error?.message || '알 수 없는 오류'}`);
			}
		}
	}, [
		KSK1070_R01Filter.labelPrintAuto,
		editKSK1070_R01, 
		KSK1070_R01DetailList, 
		KSK1070_R01LotMap,
		deletedKSK1070_R01DetailList,
		deletedKSK1070_R01LotList,
		printBulkLabel,
		setDetailFetchTrigger,
		defaultKSK1070_R01HeaderRow,
		defaultKSK1070_R01LotRow,
	])

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleDetailInfoCode = useCallback((headerData: KSK1070_R01HeaderDto): Partial<KSK1070_R01HeaderDto> => {
		const defaults: Partial<KSK1070_R01HeaderDto> = {};
		
		//일자를 당일로 초기화
		defaults.orderDt = formatDate(new Date());
	
		if (!validateString(headerData.compCd) && compCdList.length > 0) defaults.compCd = compCdList[0].compCd;
		if (!validateString(headerData.inoutMethod) && inoutMethodList.length > 0) defaults.inoutMethod = inoutMethodList[0].minorCd;

		if (!validateString(headerData.logicCenter) && wmsCdList.length > 0){
			defaults.logicCenter = wmsCdList[0].minorCd;
		}
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;

		let warehouseCdListToUse = warehouseCdListToUseList(defaults.logicCenter || '');
		if (!validateString(headerData.warehouseCd) && warehouseCdListToUse.length > 0) {
			defaults.warehouseCd = warehouseCdListToUse[0].warehouseCd;
		}
		defaults.warehouseCd = headerData.warehouseCd ? headerData.warehouseCd : defaults.warehouseCd;

		if (!validateString(headerData.inoutClass) && wmsInTypeCdList.length > 0) defaults.inoutClass = wmsInTypeCdList[0].minorCd;
		defaults.inoutClass = validateString(headerData.inoutClass) ? headerData.inoutClass : defaults.inoutClass;
	
		return defaults;
	}, [inoutMethodList, wmsCdList, compCdList, warehouseCdList]);
	
	const handleFetchDetailList = useCallback(async (wmsOrderNo: string, warehouseCd: string, isNewSelection: boolean, previousOrderNo: string | undefined) => {
		setLoadingSpinner(true);
		if (!warehouseCd) {
			showError('발주 정보의 물류정보의 조건에 맞는 창고 코드를 찾을 수 없어 입고 목록 내역을 조회할 수 없습니다.', 5000);
			setKSK1070_R01DetailList([]);
			await resetKSK1070_R01LotList([]);
			setSelectedKSK1070_R01DetailList([]);
			setSelectedItemCdForLot(null);
			setLoadingSpinner(false);
			return;
		}
		setLoadingSpinner(true);
		// 이전에 선택한 입고정보와 현재 선택한 입고정보가 같으면 상세내역 검색 중단
		if(!isNewSelection) { setLoadingSpinner(false); return; }

		try {
			const detailResponse = await getKSK1070_R01DetailList(wmsOrderNo, warehouseCd);
			const detailData = detailResponse.data.data;

			if (detailData && detailData.length > 0) {
				const updatedDetails = detailData.map((value) => {
					return {
						...value,
						valueIndex: value.valueIndex,
						orderIndex: value.orderIndex,
						orderIndexSeq: value.orderIndexSeq,
						orderPrice: value.orderPrice,
						orderQtyView: value.orderQty - value.transportQty - value.cancelQty,
						updateTransportQty: 0,
					}
				});
				setKSK1070_R01DetailList(updatedDetails);
				setOriginalKSK1070_R01DetailList(detailData);
				setMessage(`${editKSK1070_R01?.compNm}의 입고지시내역 ${detailData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);

				const firstDetail = useKSK1070_R01Store.getState().KSK1070_R01DetailList[0];
				await resetKSK1070_R01LotList(firstDetail ? [firstDetail] : []);
				if (firstDetail) {
					setSelectedKSK1070_R01DetailList([firstDetail.valueIndex] as any);
					setSelectedItemCdForLot(firstDetail.itemCd);
				}
				
			} else {
				showError('상세내역이 없습니다.');
				setKSK1070_R01DetailList([]);
				await resetKSK1070_R01LotList([]);
				setSelectedKSK1070_R01DetailList([]);
				setSelectedItemCdForLot(null);
				setLoadingSpinner(false);
			}
		} catch (error) {
			console.error("상세 내역 조회 실패:", error);
			showError('상세 내역을 조회하는 중 오류가 발생했습니다.');
			setKSK1070_R01DetailList([]);
			await resetKSK1070_R01LotList([]);
			setSelectedKSK1070_R01DetailList([]);
			setSelectedItemCdForLot(null);
			setLoadingSpinner(false);
		}
		setLoadingSpinner(false);
	}, [
		setMessage, 
		setKSK1070_R01DetailList,
		setOriginalKSK1070_R01DetailList,
		editKSK1070_R01?.compNm,
		resetKSK1070_R01LotList,
		setSelectedKSK1070_R01DetailList,
		setSelectedItemCdForLot,
		setAutoLotQtyIfEmpty,
	]);

	const handleFetchLotList = useCallback(async (
		itemCd: string
	) => {
		if (!itemCd) {
			setKSK1070_R01LotMap(new Map<string, KSK1070_R01LotDto[]>());
			setKSK1070_R01LotList([]);
			setOriginalKSK1070_R01LotList([]);
			return;
		}

		setSelectedItemCdForLot(itemCd);

		const state = useKSK1070_R01Store.getState();
		const selectedDetail =
			state.KSK1070_R01DetailList.find(d => d.itemCd === itemCd)
			|| state.KSK1070_R01DetailList.find(d =>
				state.selectedKSK1070_R01DetailList.includes(d.valueIndex as any)
			);
		if (selectedDetail) {
			setAutoLotQtyIfEmpty(selectedDetail);
		}

	}, [
		setKSK1070_R01LotList,
		setOriginalKSK1070_R01LotList,
		setSelectedItemCdForLot,
		setKSK1070_R01LotMap,
		setAutoLotQtyIfEmpty,
	]);



	useEffect(() => {
		if (!detailFetchTrigger) return;
		const fetchAllDetailsForSelectedRow = async () => {
			const wmsOrderNo = editKSK1070_R01?.wmsOrderNo;
			if (!wmsOrderNo) {
				setKSK1070_R01DetailList([]);
				setOriginalKSK1070_R01DetailList([]);
				setKSK1070_R01LotList([]);
				setOriginalKSK1070_R01LotList([]);
				prevWmsOrderNoRef.current = undefined;
				prevWarehouseCdRef.current = undefined;
				setDetailFetchTrigger(false);
				return;
			}

			// 이전에 선택한 입고정보/창고와 다르면 상세 내역 재조회
			const previousOrderNo = prevWmsOrderNoRef.current;
			const previousWarehouseCd = prevWarehouseCdRef.current;
			const currentOrderNo = wmsOrderNo;
			const currentWarehouseCd = editKSK1070_R01?.warehouseCd || '';

			const isNewSelection =
				previousOrderNo !== currentOrderNo
				|| previousWarehouseCd !== currentWarehouseCd;

			// 1. 입고 정보 먼저 가져오기
			const headerData = await fetchOne();

			// 2.출하 정보 먼저 가져와서 완전한 입고 정보인지 출하 전의 입고 정보인지 검증
			// 출하 정보 존재시 수정 불가
			const apiHeaderData = await fetchTransportHeader();
			if (apiHeaderData)	setTransportComplete(true);
			else				setTransportComplete(false);

			// 3. 현재 편집 헤더와 API 데이터를 합쳐 기본값을 적용할 베이스 데이터를 만듭니다.
			const baseDataForDefaults = { ...defaultKSK1070_R01HeaderRow(), ...headerData, ...(apiHeaderData || {}) };
			const defaultValues = handleDetailInfoCode(baseDataForDefaults);

			// 최종 warehouseCd: 사용자가 Info에서 바꾼 창고를 우선 사용
			const logicCenterToUse = editKSK1070_R01?.logicCenter || baseDataForDefaults.logicCenter || defaultValues.logicCenter || '';
			const warehouseCdToUse = currentWarehouseCd || baseDataForDefaults.warehouseCd || defaultValues.warehouseCd || '';

			// 4. 입고 헤더 정보 업데이트 (창고는 현재 선택값 유지)
			setEditKSK1070_R01({
				...defaultKSK1070_R01HeaderRow(),
				...headerData,
				...defaultValues,
				logicCenter: logicCenterToUse,
				warehouseCd: warehouseCdToUse,
			});

			// 5. 분리된 함수를 호출하여 상세 내역을 등록.
			await handleFetchDetailList(wmsOrderNo, warehouseCdToUse, isNewSelection, previousOrderNo);
			prevWmsOrderNoRef.current = wmsOrderNo;
			prevWarehouseCdRef.current = warehouseCdToUse;
			setDetailFetchTrigger(false);
		};

		fetchAllDetailsForSelectedRow();
	}, [detailFetchTrigger, editKSK1070_R01?.wmsOrderNo, editKSK1070_R01?.warehouseCd, setEditKSK1070_R01, setLoadingSpinner]);

	// 출하여부 판단 후 출하여부 존재시 발주정보 수정불가 처리
	useEffect(() => {
		const checkWmsTransport = async () => {
			setLoadingSpinner(true);
			if (!editKSK1070_R01?.wmsOrderNo) {
				setTransportComplete(false);
				setLoadingSpinner(false);
				return;
			}
			
			const response = await getKSK1070_R01WmsTransport(editKSK1070_R01?.wmsOrderNo || '');
			if (
				response.data.data &&
				response.data.data.transportNo !== null && response.data.data.transportNo !== '') {				
				setTransportComplete(true);
			} else {
				setTransportComplete(false);
			}
			setLoadingSpinner(false);
		};

		checkWmsTransport();
	}, [editKSK1070_R01?.wmsOrderNo, setLoadingSpinner]);


	useEffect(() => {
		if (company) {
			setKSK1070_R01Filter({ labelPrintAuto: company.labelPrintAuto || 'N' });
		}
	}, [company, setKSK1070_R01Filter]);
	
	return {
		clickable, setClickable,
		handleExcelClick,
		fetchSelectedOrder,
		handleSearchClick,
		defaultKSK1070_R01HeaderRow,
		defaultKSK1070_R01DetailRow,
		defaultKSK1070_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleInsertClick,
		handleSaveClick,
		handleFetchDetailList,
		warehouseCdListToUseList,
		handleDetailInfoCode,
		handleFetchLotList,
		getWmsOrderFieldHandlers,
	};
}
